export const GET_ALL_ONLINE_EXAM = 'GET_ALL_ONLINE_EXAM';
export const GET_QUESTIONS_EACH_EXAM = 'GET_QUESTIONS_EACH_EXAM';
export const GET_ALL_EXAM_RESULT = 'GET_ALL_EXAM_RESULT';
